module.exports = __webpack_public_path__ + "img/onekids-logo.ac27d1b1.png";